import React from 'react';
export function Story() {
  return <section className="py-[60px] px-5 bg-brand-dark" data-id="element-303">
      <div className="max-w-[860px] mx-auto" data-id="element-304">
        <h2 className="text-[clamp(22px,4vw,36px)] font-black text-white mb-3 text-center" data-id="element-305">
          La Historia que Nadie Quiere Contar
        </h2>

        <div className="max-w-[720px] mx-auto bg-brand-dark2 border border-brand-border rounded-2xl p-10 sm:p-7 sm:px-5" data-id="element-306">
          <p className="text-base leading-[1.8] text-[#cdd9e5] mb-5" data-id="element-307">
            Era un viernes por la tarde en Houston. Marco llevaba tres semanas
            trabajando sin parar en un proyecto de drywall. Había cobrado bien.
            Mejor que en meses.
          </p>
          <p className="text-base leading-[1.8] text-[#cdd9e5] mb-5" data-id="element-308">
            Cuando la policía lo paró en la carretera, ni siquiera estaba
            nervioso. Hasta que el oficial le dijo:{' '}
            <em className="italic" data-id="element-309">"Su seguro está vencido, señor."</em>
          </p>
          <p className="text-base leading-[1.8] text-[#cdd9e5] mb-5" data-id="element-310">
            Marco sabía que había una carta del seguro en la guantera. La había
            visto. La había movido varias veces. Simplemente nunca la había
            abierta.
          </p>

          <div className="text-[clamp(18px,3vw,24px)] font-black text-brand-red border-l-4 border-brand-red pl-5 my-7 leading-[1.4]" data-id="element-311">
            La multa fue de $500. Los fees del seguro atrasado: $120 más. Total
            perdido: $620 — por no tener un sistema.
          </div>

          <p className="text-base leading-[1.8] text-[#cdd9e5] mb-5" data-id="element-312">
            En ese momento Marco hizo el cálculo que nunca había querido hacer:{' '}
            <strong className="text-white" data-id="element-313">
              Había ganado más de $4,000 ese mes. Y no podía pagar $180 de
              seguro.
            </strong>
          </p>

          <div className="text-center text-[clamp(22px,4vw,30px)] font-black text-white p-6 bg-brand-red/10 border border-brand-red/20 rounded-xl my-7" data-id="element-314">
            ¿Te suena familiar?
          </div>

          <p className="text-base leading-[1.8] text-[#cdd9e5] mb-5" data-id="element-315">
            No porque seas irresponsable. No porque gastes de más.{' '}
            <strong className="text-white" data-id="element-316">
              Sino porque nadie te enseñó un sistema que funcione con ingresos
              que cambian cada semana.
            </strong>
          </p>
        </div>
      </div>
    </section>;
}